import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { LocalVideoBloc } from "./LocalVideoBloc";
import { useContext } from "react";

export const LocalVideoContext = createBlocContext<LocalVideoBloc>();

export function useLocalVideoContext() {
  const ctx = useContext(LocalVideoContext);
  return ctx;
}

export const LocalVideoBlocProvider = createBlocProvider<LocalVideoBloc>(
  LocalVideoBloc.create(),
  LocalVideoContext
);
